module.exports = __webpack_public_path__ + "img/icon_map_199_on_111.b4265c21.png";